import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './i18n';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VCalendar from 'v-calendar';
import '@/utils/boot';
import Dropdown from '@/plugins/dropdown';

Vue.use(Dropdown);

// Import global styles
import '@/assets/app.scss';

// Declare global meta
import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

import VueGtm from 'vue-gtm';
declare module 'vue/types/vue' {
  interface Vue {
    $gtm: any;
    $dropdown: any;
  }
}

// Declare global pretty checkbox
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

// Add font awesome needed icons
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamation,
  faBan,
  faBed,
  faTimes,
  faCheck,
  faCalendarAlt,
  faCalendar,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faSpinner,
  faCheckCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
library.add(
  faExclamation,
  faBan,
  faBed,
  faTimes,
  faCheck,
  faCalendarAlt,
  faCalendar,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faSpinner,
  faCheckCircle,
  faInfoCircle,
);

Vue.config.productionTip = false;
Vue.config.devtools = process.env.VUE_APP_DEV_TOOLS_ENABLED !== '0' || false;

const moment = require('moment');
Vue.use(require('vue-moment'), { moment });
Vue.use(VCalendar);

// Declare global font awesome tag
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Declare sticky directive
Vue.directive('sticky', {
  inserted: (el, binding) => {
    const f = (evt: Event) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_KEY || 'GTM-MHXLBBJ',
  enabled: process.env.VUE_APP_GTM_ENABLED !== '0' || false,
  debug: process.env.VUE_APP_GTM_DEBUG !== '0' || false,
  vueRouter: router,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
